function LowerLogo() {
    return(
        <>
            <img src={"Color.png"} className={"lower-logo"}></img>
        </>
    )
}

export default LowerLogo